<template>
  <div>
    <div class="row">
      <spinner v-if="loading.email || loading.creatingEmail || loading.updatingEmail"></spinner>
      <form v-else data-vv-scope="new-email">
        <div class="col-md-5">
          <div class="form-group">
            <label for="email-template">Template</label>
            <select class="form-control" id="email-template" v-model="email.template_id" @change="applyTemplate">
              <option :value="null">Select template...</option>
              <option v-for="template in templates" :value="template.id">{{template.name}}</option>
            </select>
          </div>

          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-subject') }">
            <label for="email-body">* Subject</label>
            <textarea class="form-control"
                      rows="2"
                      v-model="email.subject"
                      placeholder="Subject"
                      name="new-email-subject"
                      v-validate="'required'"
                      data-vv-as="Subject"
                      :disabled="email.status !== this.messagesStatuses.DRAFTING"></textarea>
            <span v-show="errors.has('new-email.new-email-subject')" class="help-block ">{{ errors.first('new-email.new-email-subject') }}</span>
          </div>
          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-header') }">
            <label for="email-header">* Header Banner</label>
            <input type="text"
                   class="form-control"
                   id="email-header"
                   v-model="email.header"
                   placeholder="Header (Banner)"
                   name="new-email-header"
                   v-validate="'required'"
                   data-vv-as="Header Banner"
                   :disabled="email.status !== this.messagesStatuses.DRAFTING"/>
            <span v-show="errors.has('new-email.new-email-header')" class="help-block ">{{ errors.first('new-email.new-email-header') }}</span>
          </div>
          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-sincerely') }">
            <label for="email-sender">* Sincerely,</label>
            <select class="form-control"
                    id="email-sender"
                    v-model="email.sender"
                    name="new-email-sincerely"
                    data-vv-as="Sincerely"
                    v-validate="'required'"
                    :disabled="email.status !== this.messagesStatuses.DRAFTING">
              <option :value="null" disabled selected>Select option...</option>
              <option v-for="sender, senderKey in newEmailOptions.senders" :value="senderKey">{{sender.name}} <{{sender.email}}></option>
            </select>
            <span v-show="errors.has('new-email.new-email-sincerely')" class="help-block ">{{ errors.first('new-email.new-email-sincerely') }}</span>
          </div>

          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-recipients-group') }">
            <label for="email-recipients-group">* Recipient(s)</label>
            <select class="form-control" id="email-recipients-group"
                    v-model="email.recipients_group"
                    @change="setRecipientsGroup"
                    v-validate="'required'"
                    name="new-email-recipients-group"
                    data-vv-as="Recipient(s)"
                    :disabled="email.status !== this.messagesStatuses.DRAFTING"
            >
              <option :value="null" disabled selected>Select option...</option>
              <option v-for="groupName, groupKey in newEmailOptions.recipients_groups" :value="groupKey">
                {{groupName}}
              </option>
            </select>
            <span v-show="errors.has('new-email.new-email-recipients-group')" class="help-block ">{{ errors.first('new-email.new-email-recipients-group') }}</span>
          </div>

          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-recipients-option') }" v-if="email.recipients_group == 'users_by_role'">
            <label for="email-recipients-by-role">* User Role</label>

            <select class="form-control" id="email-recipients-by-role"
                    v-model="email.recipients_option"
                    @change="setRecipientsOption"
                    name="new-email-recipients-option"
                    data-vv-as="User Role"
                    v-validate="'required'"
                    :disabled="email.status !== this.messagesStatuses.DRAFTING"
            >
              <option :value="null" disabled selected>Select option...</option>
              <option value="volunteers">Volunteer</option>
              <option value="case_managers">Case Manager</option>
              <option value="supervisors">Supervisor</option>
              <option value="program_administrators">Program Administrator</option>
            </select>
            <span v-show="errors.has('new-email.new-email-recipients-option')" class="help-block ">{{ errors.first('new-email.new-email-recipients-option') }}</span>
          </div>

          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-recipients-option') }" v-if="email.recipients_group == 'users_by_account'">
            <label for="email-recipients-by-account">* Accounts</label>

            <vue-select id="email-recipients-by-account"
                        v-model="email.recipients_option"
                        :options="newEmailOptions.accounts"
                        label="name"
                        @change="setRecipientsOption"
                        name="new-email-recipients-option"
                        data-vv-as="User Account"
                        v-validate="'required'"
                        :multiple="true"
                        :disabled="email.status !== this.messagesStatuses.DRAFTING"
            >
            </vue-select>
            <span v-show="errors.has('new-email.new-email-recipients-option')" class="help-block ">{{ errors.first('new-email.new-email-recipients-option') }}</span>
          </div>

          <!--                    <option :value="null" disabled selected>Select option...</option>-->
          <!--                    <option v-for="account in newEmailOptions.accounts" :value="account.id">{{account.name}}-->
          <!--                    </option>-->

          <div class="form-group" :class="{ 'has-error': errors.has('new-email.new-email-recipients') }">
            <label>* Recipient(s)</label>

            <vue-select
              v-model="email.recipients"
              :options="recipientsInGroup"
              :multiple=true
              :taggable="email.recipients_group=='custom'"
              placeholder="Select recipients..."
              data-vv-name="new-email-recipients"
              data-vv-as="Recipients"
              v-validate="'required|emails_arr'"
              :disabled="email.status !== this.messagesStatuses.DRAFTING"

            >
            </vue-select>
            <span v-show="errors.has('new-email.new-email-recipients')" class="help-block ">{{ errors.first('new-email.new-email-recipients') }}</span>
          </div>

          <div class="form-group" v-if="email.hasOwnProperty('failedRecipients') && email.failedRecipients.length">
            <label style="color: #f00">Failed recipient(s)</label>
            <vue-select
              v-model="email.failedRecipients"
              :multiple=true
              :disabled="true"
            >
            </vue-select>
          </div>

          <button class="btn green" @click.prevent="saveEmail(true)" v-if="email.status == this.messagesStatuses.DRAFTING">Send email</button>
          <button class="btn default" @click.prevent="saveEmail(false)" v-if="email.status == this.messagesStatuses.DRAFTING">Save</button>
          <button class="btn default" @click.prevent="$emit('back')">Back</button>

        </div>

        <div class="col-md-7">
          <shortcodes-editor
            v-model="email.body"
            label="Body"
            name="body"
            validation-scope="new-email"
            validators="required"
            rows="20"
            :shortcodes="shortcodes"
          />
        </div>
      </form>
    </div>
  </div>

</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Spinner from "@/components/Spinner";
import ShortcodesEditor from "@/components/forms/ShortcodesEditor";
import VueSelect from 'vue-select';
import {EMAIL_MESSAGE_STATUS} from "@/enums/emails"

export default {

  components: {
    Spinner,
    VueSelect,
    ShortcodesEditor,
  },
  data() {
    return {
      recipientsInGroup: [],
      messagesStatuses: EMAIL_MESSAGE_STATUS,
      shortcodes: ['first_name','last_name','email']
    }
  },

  computed: {
    ...mapGetters({
      appUser: 'getUser',
      newEmailOptions: 'emails/getNewEmailOptions',
      email: 'emails/getEmail',
      templates: 'emails/getTemplates',
      loading: 'emails/getLoading'
    }),
  },

  mounted() {
    this.fetchNewEmailOptions();
    this.fetchTemplates().then(() => {
      if(!this.email.id && this.email.template_id) {
        this.applyTemplate(this.email.template_id);
      }
    })
  },

  methods: {
    applyTemplate() {

      let template = this.templates.find(item => item.id == this.email.template_id);

      if(template === undefined) {
        return;
      }

      this.email.body = template.body;
      this.email.header = template.header;
      this.email.subject = template.subject;
      this.email.sender = template.sender;
    },
    saveEmail(send = false) {
      if(this.email.status !== 0) {
        return;
      }

      this.$validator.validateAll('new-email').then((result) => {
        if (result) {

          if(this.email.id !== null) {
            this.updateEmail({send: send}).then((response) => {
              this.$notify('Email updated!');
            });

            return;
          }

          this.createEmail({send: send}).then((response) => {
            if(response.data.status == 'success') {
              this.$notify('New email created!');
              if(send) {
                this.resetEmail();
                this.$router.push({name: 'Email Settings', hash: '#email-history'});
              }
            } else {
              this.$notify({type: 'error', text: 'Something went wrong while saving email.'});
            }
          })
        }
      });
    },
    ...mapActions('emails', [
      'fetchNewEmailOptions',
      'fetchTemplates',
      'createEmail',
      'updateEmail',
      'resetEmail'
    ]),

    setRecipientsGroup() {
      this.email.recipients_option = null;
      this.$validator.reset();
      if(this.email.recipients_group !== 'all_users') {
        this.email.recipients = [];
      }
      if (this.email.recipients_group == 'all_users') {
        let emails = this.newEmailOptions.users_by_role['all_users'].map(item => item.email);
        this.email.recipients = emails;
        this.recipientsInGroup = emails;
      }
    },

    setRecipientsOption() {
      if (this.email.recipients_group == 'users_by_account' && this.email.recipients_option) {

        let emails = [];

        this.email.recipients_option.forEach(account => {
          this.newEmailOptions.users_by_account['account' + account.id].forEach(item => {
            if(!emails.includes(item.email)) {
              emails.push(item.email);
            }
          })
        })

        this.email.recipients = emails;
        this.recipientsInGroup = emails;
      }

      if (this.email.recipients_group == 'users_by_role' && this.email.recipients_option) {
        let emails = this.newEmailOptions.users_by_role[this.email.recipients_option].map(item => item.email);
        this.email.recipients = emails;
        this.recipientsInGroup = emails;
      }
    },
  },
  watch: {
    recipients_group: function (newVal) {
      if(newVal === 'users_by_account') {
        if(!this.recipients_option.isArray()) {
          this.recipients_option = [];
        }
      }
    }
  },

  inject: {
    $validator: '$validator'
  },
}
</script>



// WEBPACK FOOTER //
// EditEmail.vue?3c3cdca0